import { Injectable } from '@angular/core';
import { DiscountType } from '../../../models/discountCode/enums/discountType.enum';
import { BasketItem } from '../models/basketItem.model';

@Injectable({
  providedIn: 'root',
})
export class BasketItemsService {
  private _items: BasketItem[] = [];

  constructor() {
    this._items = JSON.parse(localStorage.getItem('basketItems') || '[]');
  }

  remove(item: BasketItem) {
    const index = this._items.indexOf(item);
    this._items.splice(index, 1);
    this.syncItems();
  }

  add(item: BasketItem) {

    const existingItem = this._items.find(x => x.id === item.id);
    if (existingItem) {
      this.remove(existingItem)
    };
    this._items.push(item);
    this.syncItems();
  }

  clear() {
    this._items = [];
    this.syncItems();
  }

  isBasketEmpty() {
    return !this.items?.length;
  }

  get length(): number {
    return this._items.length;
  }

  get total(): number {
    return Number(
      this._items.reduce((total, item) => total + item.price, 0).toFixed(2),
    );
  }

  get items() {
    return this._items.slice(0);
  }

  getById(id: string): BasketItem | undefined {
    return this._items.find(x => x.id === id);
  }

  syncItems() {
    this._items.forEach((x) => {
      var price = x.basePrice;
      x.pricePreDiscount = price;

      if (x.discountCode) {
        if (x.discountCode!.discountType == DiscountType.Percentage) {
          price *= (100 - x.discountCode!.discountPercentageValue) / 100;
        } else {
          price = Math.max(price - x.discountCode!.discountAmountValue, 0);
        }
      }

      x.price = price;
    });

    localStorage.setItem('basketItems', JSON.stringify(this._items));
  }
}
